import { getEntityName } from "../../../../utils/user/get-entity-name"
import type { Project, ProjectCustomer } from "../../types/project.types.ts"

// project.types.ts's ProjectCustomer predates phone_2/address_2 being wired
// up, but the API has always returned both (CustomerContactSection and
// CustomerAddressSection already read them off a picked customer) — this is
// a read-side type fix, not a new field.
type ProjectCustomerWithSecondaryPhone = ProjectCustomer & {
  phone_2?: string | null
  address_2: string | null
}

interface ProjectOverviewCustomerValues {
  first_name: string | null
  last_name: string | null
  email: string | null
  phone: string | null
  phone_2: string | null
}

/** A linked `customer` wins over a manually-entered `temporary_customer`. */
const projectCustomerRecord = (
  project?: Project | null
): ProjectCustomerWithSecondaryPhone | null =>
  (project?.customer ||
    project?.temporary_customer ||
    null) as ProjectCustomerWithSecondaryPhone | null

const projectCustomerValues = (
  project?: Project | null
): ProjectOverviewCustomerValues => {
  const customer = projectCustomerRecord(project)

  return {
    first_name: customer?.first_name ?? null,
    last_name: customer?.last_name ?? null,
    email: customer?.email ?? null,
    phone: customer?.phone ?? null,
    phone_2: customer?.phone_2 ?? null
  }
}

const projectCustomerName = (project?: Project | null): string =>
  getEntityName(projectCustomerRecord(project), "")

/** Only a real linked customer has an id — and therefore a page to open. */
const isLinkedProjectCustomer = (project?: Project | null): boolean =>
  !!project?.customer?.id

const linkedProjectCustomerId = (project?: Project | null): string | null =>
  project?.customer?.id ?? null

export {
  type ProjectOverviewCustomerValues,
  projectCustomerRecord,
  projectCustomerValues,
  projectCustomerName,
  isLinkedProjectCustomer,
  linkedProjectCustomerId
}
